import type { PerformanceBarLabelState } from '~/features/my-wallet/types/charts'

export const PERFORMANCE_WINDOW_DAYS = 90

export const SLA_ON_TIME_DAYS = {
  SOLFACIL_COMBO: 45,
  OTHER_DISTRIBUTOR: 45,
} as const

export type KitType = keyof typeof SLA_ON_TIME_DAYS

export const KIT_TYPES: KitType[] = ['SOLFACIL_COMBO', 'OTHER_DISTRIBUTOR']

export const MODEL_KEYS = ['C', 'B', 'A'] as const

export type ModelKey = typeof MODEL_KEYS[number]

export const MODEL_CARD_STATES = ['ENABLED', 'DEFAULT', 'LOCKED', 'DISABLED', 'BLOCKED', 'WAIVED'] as const

export type ModelCardState = typeof MODEL_CARD_STATES[number]

interface ModelCardStatePresentation {
  isActive: boolean
  barLabelState: PerformanceBarLabelState
}

export const MODEL_CARD_STATE_PRESENTATION: Record<ModelCardState, ModelCardStatePresentation> = {
  ENABLED: { isActive: true, barLabelState: 'unlocked' },
  DEFAULT: { isActive: true, barLabelState: 'unlocked' },
  WAIVED: { isActive: true, barLabelState: 'waived' },
  LOCKED: { isActive: false, barLabelState: 'locked' },
  DISABLED: { isActive: false, barLabelState: 'locked' },
  BLOCKED: { isActive: false, barLabelState: 'locked' },
}

export const UNKNOWN_MODEL_CARD_STATE_PRESENTATION: ModelCardStatePresentation = { isActive: false, barLabelState: 'locked' }

export const MY_WALLET_ROUTE = '/minha-carteira'

export const PROJECTS_ROUTE = '/projects'

// Same `steps` query the projects page reads for its "Etapa" filter
export const PROJECTS_INSTALLATION_QUERY = { steps: 'installation' } as const

export const REASON_KEY_PREFIXES = {
  MODEL_DISABLED: 'my_wallet.receiving_model.performance.disabled_reasons',
} as const

export const MY_WALLET_ANCHORS = {
  PERFORMANCE: 'my-wallet-performance',
  FAQ: 'my-wallet-faq',
} as const
